import { defineMessages } from 'react-intl';
import { mcpSiteSelectorMessages as sharedMessages } from '../../MCP/SiteSelector/messages';

/**
 * Only the messages this flow adds or rewords are declared here; the rest are
 * reused from the default flow so each id is declared once and keeps its
 * translations. `defineMessages` is what the formatjs extractor reads, so
 * spreading the shared object below does not re-extract those ids.
 *
 * The reworded copy takes new ids rather than editing the default flow's, so
 * both flows can run at once without one changing the other's strings.
 */
const optionalSitesMessages = defineMessages({
  siteLabel: {
    id: 'oauth.mcp.siteSelector.label.sites',
    defaultMessage: 'Site (For Jira, Confluence and other tools)',
    description: 'Label above the site-picker dropdown',
  },
  sitePlaceholder: {
    id: 'oauth.mcp.siteSelector.placeholder.plural',
    defaultMessage: 'Select',
    description: 'Placeholder text inside the multi-select site picker',
  },
  noSites: {
    id: 'oauth.mcp.siteSelector.noSites',
    defaultMessage:
      "Your account isn't associated with a supported site. Rovo MCP connects with Atlassian sites that use apps like Jira or Confluence. {learnMoreLink}",
    description:
      'Message below the disabled site picker when the user has no supported sites; {learnMoreLink} links to Rovo MCP documentation',
  },
  noPermissions: {
    id: 'oauth.mcp.siteSelector.noPermissions',
    defaultMessage:
      'Permissions are blocked for this site, contact your admin or {learnMoreLink}',
    description:
      'Message below the site picker when the permission check succeeded but returned no permissions; {learnMoreLink} links to the admin guide for managing MCP permissions',
  },
  noPermissionsLearnMore: {
    id: 'oauth.mcp.siteSelector.noPermissions.learnMore',
    defaultMessage: 'see how permissions are managed',
    description:
      'Link text, inside a sentence, pointing at the admin guide for managing MCP permissions',
  },
});

export const mcpSiteSelectorMessages = {
  ...sharedMessages,
  ...optionalSitesMessages,
};
